import { useQuery } from "@tanstack/react-query";
import artistsBriefsClient from "../../../api/artists-briefs";

const useArtistsBriefsQuery = () => {
  return useQuery({
    queryKey: ["artists-briefs"],
    queryFn: () => artistsBriefsClient.getBriefs(),
  });
};

export default useArtistsBriefsQuery;
